import { render, staticRenderFns } from "./index.view.vue?vue&type=template&id=4171d0b6&scoped=true&lang=pug"
import script from "./index.view.vue?vue&type=script&lang=ts"
export * from "./index.view.vue?vue&type=script&lang=ts"
import style0 from "./index.view.vue?vue&type=style&index=0&id=4171d0b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171d0b6",
  null
  
)

export default component.exports